import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FilterByIdPipe } from './filter-by-id.pipe';
import { FilterBrandsPipe } from './filter-brands.pipe';
import { BrandSearchPipe } from './brand-search.pipe';
import { FilterMediaPipe } from './filter-media.pipe';
import { SearchBrandsPipe } from './search-brands.pipe';
import { SearchAttributePipe } from './search-attribute.pipe';
import { SearchServicePipe } from './search-service.pipe';
import { SearchTagsPipe } from './search-tags.pipe';
import { SearchAreasPipe } from './search-area.pipe';
import { SearchOffersPipe } from './search-offers.pipe';
import { SearchCategoriesPipe } from './search-categories.pipe';
import { SearchProductOffersPipe } from './search-product-offers.pipe';
import { SearchProductsPipe } from './search-products.pipe';
import { FilterCustomerPipe } from './filter-customer.pipe';
import { FilterPrivilegePipe } from './filter-privilege.pipe';
import { FilterActionsPipe } from './filter-actions.pipe';
import { FilterMappedvaluePipe } from './filter-mappedvalue.pipe';
import { FilterRolesPipe } from './filter-roles.pipe';
import { FilterRoleprivilegeactionPipe } from './filter-roleprivilegeaction.pipe';
import { FilterStoreusersPipe } from './filter-storeusers.pipe';
import { FilterStatusPipe } from './filter-status.pipe';
import { FilterProductPipe } from './filter-product.pipe';
import { FilterStorePipe } from './filter-store.pipe';
import { SearchGroupPipe } from './search-group.pipe';
import { SearchCustomerPipe } from './search-customer.pipe';
import { SearchCouponsPipe } from './search-coupons.pipe';
import { FilterVendorPipe } from './filter-vendor.pipe';
import { FilterFlyerPipe } from './filter-flyer.pipe';
import { FilterCategoriesPipe } from './filter-categories.pipe';

@NgModule({
    imports: [ 
        CommonModule 
    ],
    declarations: [
        FilterByIdPipe,
        FilterBrandsPipe,
        BrandSearchPipe,
        FilterMediaPipe,
        SearchBrandsPipe,
        SearchAttributePipe,
        SearchServicePipe,
        SearchTagsPipe,
        SearchOffersPipe,
        SearchCategoriesPipe,
        SearchProductOffersPipe,
        SearchProductsPipe,
        FilterCustomerPipe,
        FilterPrivilegePipe,
        FilterActionsPipe,
        FilterMappedvaluePipe,
        FilterRolesPipe,
        FilterRoleprivilegeactionPipe,
        FilterStoreusersPipe,
        FilterStatusPipe,
        FilterProductPipe,
        FilterStorePipe,
        FilterVendorPipe,
        SearchGroupPipe,
        SearchCustomerPipe,
        SearchCouponsPipe,
        FilterFlyerPipe,
        SearchAreasPipe,
        FilterCategoriesPipe,

    ],
    exports: [
        FilterByIdPipe,
        FilterBrandsPipe,
        BrandSearchPipe,
        FilterMediaPipe,
        SearchBrandsPipe,
        SearchAttributePipe,
        SearchServicePipe,
        SearchTagsPipe,
        SearchAreasPipe,
        SearchOffersPipe,
        SearchCategoriesPipe,
        SearchProductOffersPipe,
        SearchProductsPipe,
        FilterCustomerPipe,
        FilterPrivilegePipe,
        FilterActionsPipe,
        FilterMappedvaluePipe,
        FilterRolesPipe,
        FilterRoleprivilegeactionPipe,
        FilterStoreusersPipe,
        FilterStatusPipe,
        FilterProductPipe,
        FilterStorePipe,
        FilterVendorPipe,
        SearchGroupPipe,
        SearchCustomerPipe,
        SearchCouponsPipe,
        FilterFlyerPipe,
        FilterCategoriesPipe
        
    ]
})
export class PipesModule { }
